import { render, staticRenderFns } from "./UberOnboarding.vue?vue&type=template&id=ad5c7cc6"
import script from "./UberOnboarding.vue?vue&type=script&lang=js"
export * from "./UberOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports